<template>
	<div class="full-image" v-if="show" @keydown="onKeydown" tabindex="0">
		<div class="mask" @click="close"></div>
		<div class="image-box"
			@wheel.prevent="onWheel"
			@mousedown.prevent="onMouseDown"
			@dblclick.prevent="onDblClick"
			@contextmenu.prevent="onContextMenu"
		>
			<img :src="url" :style="imgStyle" draggable="false" />
		</div>
		<div v-if="menuVisible" class="context-menu" :style="menuStyle" @click.stop>
			<div class="menu-item" @click="onCopyImage">复制图片</div>
			<div class="menu-item" @click="onSaveImage">另存为</div>
		</div>
		<div v-if="imageList.length > 1" class="nav-btn nav-prev" :class="{ disabled: !canPrev }" title="上一张"
			@click.stop="prevImage">
			<i class="el-icon-arrow-left"></i>
		</div>
		<div v-if="imageList.length > 1" class="nav-btn nav-next" :class="{ disabled: !canNext }" title="下一张"
			@click.stop="nextImage">
			<i class="el-icon-arrow-right"></i>
		</div>
		<div class="tool-bar">
			<div class="tool-btn" title="放大" @click="zoomBy(1.2)"><i class="el-icon-zoom-in"></i></div>
			<div class="tool-btn" title="缩小" @click="zoomBy(1/1.2)"><i class="el-icon-zoom-out"></i></div>
			<div class="tool-btn" title="还原" @click="reset"><i class="el-icon-refresh"></i></div>
		</div>
		<div class="close" @click="close" title="关闭"><i class="el-icon-close"></i></div>
	</div>
</template>

<script>
export default {
	name: "fullImage",
	data() {
		return {
			show: false,
			url: '',
			scale: 1,
			offsetX: 0,
			offsetY: 0,
			dragging: false,
			dragStartX: 0,
			dragStartY: 0,
			dragOriginX: 0,
			dragOriginY: 0,
			menuVisible: false,
			menuX: 0,
			menuY: 0,
			imageList: [],
			currentIndex: 0,
		}
	},
	computed: {
		imgStyle() {
			// 注意：这里用 translate(-50%,-50%) 做居中，再叠加用户拖拽偏移和缩放
			return {
				transform: `translate(calc(-50% + ${this.offsetX}px), calc(-50% + ${this.offsetY}px)) scale(${this.scale})`
			};
		},
		menuStyle() {
			return {
				left: `${this.menuX}px`,
				top: `${this.menuY}px`
			};
		},
		canPrev() {
			return this.imageList.length > 1 && this.currentIndex > 0;
		},
		canNext() {
			return this.imageList.length > 1 && this.currentIndex < this.imageList.length - 1;
		}
	},
	methods: {
		open(payload) {
			let url = '';
			let list = [];
			if (typeof payload === 'string') {
				url = payload;
			} else if (payload && typeof payload === 'object') {
				url = payload.url || '';
				if (Array.isArray(payload.urls)) {
					list = payload.urls.filter(Boolean);
				}
			}
			if (!url) return;
			if (!list.length) {
				list = [url];
			}
			const idx = list.indexOf(url);
			this.imageList = list;
			this.currentIndex = idx >= 0 ? idx : 0;
			this.show = true;
			this.url = list[this.currentIndex] || url;
			this.reset();
			this.$nextTick(() => {
				// 让 esc 生效
				this.$el && this.$el.focus && this.$el.focus();
			});
		},
		close() {
			this.show = false;
			this.hideContextMenu();
		}
		,
		reset() {
			this.scale = 1;
			this.offsetX = 0;
			this.offsetY = 0;
			this.dragging = false;
			this.hideContextMenu();
		},
		clampScale(next) {
			// 避免无限放大缩小导致卡顿/不可用
			return Math.max(0.2, Math.min(8, next));
		},
		zoomAt(clientX, clientY, factor) {
			const box = this.$el && this.$el.querySelector && this.$el.querySelector('.image-box');
			if (!box) {
				this.scale = this.clampScale(this.scale * factor);
				return;
			}
			const rect = box.getBoundingClientRect();
			const cx = clientX - rect.left - rect.width / 2;
			const cy = clientY - rect.top - rect.height / 2;
			const oldScale = this.scale;
			const newScale = this.clampScale(oldScale * factor);
			const k = newScale / oldScale;
			// 让缩放围绕鼠标点，平移做补偿
			this.offsetX = this.offsetX - cx * (k - 1);
			this.offsetY = this.offsetY - cy * (k - 1);
			this.scale = newScale;
		},
		zoomBy(factor) {
			// 按按钮缩放时以视口中心为基准
			this.scale = this.clampScale(this.scale * factor);
		},
		prevImage() {
			if (!this.canPrev) return;
			this.currentIndex -= 1;
			this.url = this.imageList[this.currentIndex];
			this.reset();
		},
		nextImage() {
			if (!this.canNext) return;
			this.currentIndex += 1;
			this.url = this.imageList[this.currentIndex];
			this.reset();
		},
		onKeydown(e) {
			if (e.key === 'Escape') {
				this.close();
				return;
			}
			if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
				this.prevImage();
				return;
			}
			if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
				this.nextImage();
			}
		},
		onWheel(e) {
			const factor = e.deltaY > 0 ? (1 / 1.1) : 1.1;
			this.zoomAt(e.clientX, e.clientY, factor);
		},
		onDblClick(e) {
			// 双击在 1 和 2 之间切换，并尽量围绕双击点缩放
			const target = this.scale > 1 ? 1 : 2;
			const factor = target / this.scale;
			this.zoomAt(e.clientX, e.clientY, factor);
		},
		onMouseDown(e) {
			this.dragging = true;
			this.dragStartX = e.clientX;
			this.dragStartY = e.clientY;
			this.dragOriginX = this.offsetX;
			this.dragOriginY = this.offsetY;
			window.addEventListener('mousemove', this.onMouseMove);
			window.addEventListener('mouseup', this.onMouseUp);
		},
		onMouseMove(e) {
			if (!this.dragging) return;
			this.offsetX = this.dragOriginX + (e.clientX - this.dragStartX);
			this.offsetY = this.dragOriginY + (e.clientY - this.dragStartY);
		},
		onMouseUp() {
			this.dragging = false;
			window.removeEventListener('mousemove', this.onMouseMove);
			window.removeEventListener('mouseup', this.onMouseUp);
		},
		onContextMenu(e) {
			this.menuX = e.clientX;
			this.menuY = e.clientY;
			this.menuVisible = true;
		},
		hideContextMenu() {
			this.menuVisible = false;
		},
		async fetchImageBlob() {
			const res = await fetch(this.url, { mode: 'cors' });
			if (!res.ok) {
				throw new Error('fetch image failed');
			}
			return await res.blob();
		},
		async onCopyImage() {
			try {
				const ClipboardItemCtor = window.ClipboardItem;
				if (!navigator.clipboard || typeof ClipboardItemCtor === 'undefined') {
					throw new Error('clipboard api unavailable');
				}
				const blob = await this.fetchImageBlob();
				await navigator.clipboard.write([
					new ClipboardItemCtor({ [blob.type || 'image/png']: blob })
				]);
				this.$message && this.$message.success('图片已复制');
			} catch (e) {
				try {
					await navigator.clipboard.writeText(this.url);
					this.$message && this.$message.success('无法直接复制图片，已复制图片链接');
				} catch (err) {
					this.$message && this.$message.error('复制失败');
				}
			} finally {
				this.hideContextMenu();
			}
		},
		onSaveImage() {
			const link = document.createElement('a');
			link.href = this.url;
			const idx = this.url.lastIndexOf('/');
			const rawName = idx >= 0 ? this.url.slice(idx + 1).split('?')[0] : 'image';
			link.download = rawName || 'image';
			link.target = '_blank';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			this.hideContextMenu();
		}
	},
	mounted() {
		document.addEventListener('click', this.hideContextMenu);
	},
	beforeDestroy() {
		document.removeEventListener('click', this.hideContextMenu);
		window.removeEventListener('mousemove', this.onMouseMove);
		window.removeEventListener('mouseup', this.onMouseUp);
	}
}
</script>

<style lang="scss">
.full-image {
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	z-index: 9999;
	outline: none;

	.mask {
		position: fixed;
		width: 100%;
		height: 100%;
		background: black;
		opacity: 0.5;
	}

	.image-box {
		position: relative;
		width: 100%;
		height: 100%;
		cursor: grab;

		img {
			position: absolute;
			left: 50%;
			top: 50%;
			max-height: 100%;
			max-width: 100%;
			transition: transform 0.05s linear;
			user-select: none;
			-webkit-user-drag: none;
		}
	}

	.context-menu {
		position: fixed;
		z-index: 10001;
		min-width: 120px;
		background: #fff;
		border: 1px solid rgba(0, 0, 0, 0.12);
		border-radius: 6px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
		overflow: hidden;

		.menu-item {
			padding: 9px 12px;
			font-size: 13px;
			color: #333;
			cursor: pointer;
			user-select: none;

			&:hover {
				background: #f5f7fa;
			}
		}
	}

	.nav-btn {
		position: fixed;
		top: 50%;
		transform: translateY(-50%);
		z-index: 10001;
		width: 42px;
		height: 42px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background: rgba(0, 0, 0, 0.5);
		color: #fff;
		cursor: pointer;
		user-select: none;

		i {
			font-size: 20px;
			font-weight: 700;
		}

		&:hover {
			background: rgba(0, 0, 0, 0.7);
		}

		&.disabled {
			opacity: 0.35;
			cursor: not-allowed;
		}
	}

	.nav-prev {
		left: 18px;
	}

	.nav-next {
		right: 18px;
	}

	.tool-bar {
		position: fixed;
		left: 50%;
		bottom: 20px;
		transform: translateX(-50%);
		display: flex;
		gap: 10px;
		z-index: 10000;

		.tool-btn {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 40px;
			height: 40px;
			border-radius: 10px;
			background: rgba(0, 0, 0, 0.55);
			color: #fff;
			cursor: pointer;
			user-select: none;
			transition: opacity 0.2s ease;

			&:hover {
				opacity: 0.9;
			}

			i {
				font-size: 18px;
			}
		}
	}

	.close {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 20px;
		right: 20px;
		cursor: pointer;
		background: #333;
		border-radius: 50%;
		padding: 10px;
		opacity: 0.5;
		z-index: 10000;

		i {
			font-weight: bold;
			font-size: 20px;
			color: white;
		}
	}
}
</style>
